export default __webpack_public_path__ + "static/media/4.93365c4b.jpg";